import { normalizeVoiceText, removeVoicePhrase } from './matchVoiceSearchCity';

/**
 * “In my favorites” / “במועדפים שלי” (incl. common typo במעודפים).
 * Must strip before venue/keyword so leftovers do not wipe the catalog search.
 */
const FAVORITES_SCOPE_PHRASES = [
  'במעודפים שלי',
  'במועדפים שלי',
  'מהמעודפים שלי',
  'מהמועדפים שלי',
  'בתוך המועדפים שלי',
  'בתוך המעודפים שלי',
  'מתוך המועדפים שלי',
  'מתוך המעודפים שלי',
  'מתוך המועדפים',
  'מתוך המעודפים',
  'במועדפים',
  'במעודפים',
  'מהמועדפים',
  'מהמעודפים',
  'in my favorites',
  'in my favourites',
  'from my favorites',
  'from my favourites',
  'among my favorites',
  'among my favourites',
  'in the favorites',
  'in the favourites',
  'in favorites',
  'in favourites',
  'from favorites',
  'from favourites',
].sort((a, b) => b.length - a.length);

export type AssistantFavoritesScopeParse = {
  matched: boolean;
  remainder: string;
};

/** Strip favorites-scope phrases; `matched` means search should stay within saved favourites. */
export function parseAssistantFavoritesScope(text: string): AssistantFavoritesScopeParse {
  let remainder = normalizeVoiceText(text);
  if (!remainder) {
    return { matched: false, remainder: '' };
  }
  let matched = false;
  for (const phrase of FAVORITES_SCOPE_PHRASES) {
    const needle = normalizeVoiceText(phrase);
    if (!needle || !remainder.includes(needle)) {
      continue;
    }
    remainder = removeVoicePhrase(remainder, needle);
    matched = true;
  }
  return { matched, remainder };
}
